@if (partners.length > 0) {
  <div class="partners-sidebar">
    <div class="partners-header">
      <span>{{ 'sidebar.partners' | t }}</span>
      <a class="partners-all" routerLink="/advertisers">{{ 'sidebar.allMerchants' | t }}</a>
    </div>
    <div class="partners-grid">
      @for (partner of partners; track partner._id) {
        <a class="partner-logo" [routerLink]="['/advertiser', partner.advertiserName]" [title]="partner.name">
          <img [src]="partner.pictureUrl || partner.storedPictureUrl" [appImgFallback]="partner.storedPictureUrl"
            [alt]="partner.name" loading="lazy">
        </a>
      }
    </div>
  </div>
}
